/**
 * @flow
 * @author: Chinmaya
 */
// https://codepen.io/siiron/pen/jfBhy/

/* eslint-disable no-confusing-arrow, indent */

import styled from 'react-emotion'
import { mobile, notMobile } from '../../../utils/mixins'
import {
  Typo18DarkGreyBlueThreeDDI,
  Typo12DarkGreyBlueThreeDR,
  Typo14BlueGreyTwoDR,
  Typo14PumpkinOrangeDB
} from '../../../themes/Fonts/Din2014'
import Colors from '../../../themes/Colors'
import CloudinaryS3LazyLoadedImage from '../../CloudinaryS3LazyLoadedImage'
import { NewsSectionContainer } from '../styledComponents'

export const NewsTitle = styled(Typo18DarkGreyBlueThreeDDI)`
  margin-bottom: 0.25em;
  text-align: left;
  letter-spacing: normal;
  ${mobile} {
    font-size: 1.286em;
    margin-bottom: 0.286em;
  }
`
export const NewsDate = styled(Typo12DarkGreyBlueThreeDR)`
  margin-bottom: 0.25em;
  text-align: left;
  letter-spacing: normal;
  ${mobile} {
    margin-bottom: 0.429em;
    font-size: 0.929em;
  }
`
export const ReadFullStory = styled(Typo14PumpkinOrangeDB)`
  margin-bottom: 0.375em;
  text-align: left;
  text-transform: uppercase;
  &:hover {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
    outline: none;
  }
  &:focus {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
    outline: none;
  }
  &:active {
    color: ${Colors.pumpkinOrange};
    text-decoration: none;
    outline: none;
  }
  ${mobile} {
    font-size: 1em;
    margin-bottom: 2.143em;
  }
  line-height: normal;
  letter-spacing: normal;
`

export const LinkHolderText = styled.span``

export const LinkHolder = styled('article')``

export const NewsDescription = styled(Typo14BlueGreyTwoDR)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 0.375em;
  text-align: left;
  letter-spacing: normal;
  ${mobile} {
    font-size: 1em;
    margin-bottom: 0.429em;
  }
`

export const NewsImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 100%;
  height: 11.188em;
  object-fit: contain;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  ${mobile} {
    object-fit: fill;
  }
  @media (min-height: 320px) and (max-width: 426px) {
    height: auto;
  }
`
export const NewsDefaultImage = styled('div')`
  width: 100%;
  height: 8.188em;
  border-radius: 0.125em;
  background-color: #f1f8ff;
  margin-bottom: 0.75em;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NewsDescriptionHolder = styled(`div`)`
  margin: ${props => (props.imageUrl ? '0em 0.375em' : '0em')};
  box-shadow: ${props =>
    props.imageUrl ? undefined : '0 0.0625em 0.125em 0 rgba(0, 79, 192, 0.3)'};
  margin-top: ${props => (props.imageUrl ? '0.75em' : '1.375em')};
  padding: ${props => (props.imageUrl ? '0' : '1.25em')};
  display: flex;
  flex-direction: column;
  ${notMobile} {
    max-height: 11em;
    justify-content: ${props =>
      props.description !== null ? 'space-between' : 'flex-start'};
  }
  ${mobile} {
    box-shadow: ${props =>
      props.mobileImageurl
        ? undefined
        : '0 0.0625em 0.125em 0 rgba(0, 79, 192, 0.3)'};
    padding: ${props => (props.mobileImageurl ? '0' : '1.25em')};
  }
`
export const NewsImageHolder = styled('a')`
  border-radius: 0.25em;
  width: 100%;
  object-fit: contain;
  max-height: 11.25em;
  overflow: hidden;
`

export const NewsContainer = styled(NewsSectionContainer)`
  font-size: 1em;
  width: 21.25em;
  margin-bottom: 2.5em;
  @media (min-width: 320px) and (max-width: 426px) {
    margin-bottom: 2.143em;
    width: 90%;
  }
  @media (min-width: 427px) and (max-width: 767px) {
    margin-bottom: 2.143em;
    width: 18.75em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcNews/NewsCard/styledComponents.js